import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import App from './App.vue';
import router from './router.js';
import Vue3Toastify from 'vue3-toastify';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue3-toastify/dist/index.css';

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(router);
app.use(Vue3Toastify, {
  position: 'top-right',
  timeout: 5000,
  // Add more options here if needed, e.g., theme: 'light'
});

app.mount('#app');